import { createAction } from 'redux-actions';
import * as C from '../constants';
import { fetchAPI } from '../utils/api';

export const setStep = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP,
  (step: number) => ({ step })
);

export const setStep2Data = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP1_RESPONSE,
  (data: UserFavouriteTagWithChilds[]) => ({
    data,
  })
);

export const setStep3Data = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP2_RESPONSE,
  (data: UserFavouriteSubTag[]) => ({
    data,
  })
);

export const setStep2TagSelected = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP1_TAGS_SELECTED,
  (tag: UserFavouriteTagWithChilds) => ({
    tag,
  })
);

export const setStep3TagSelected = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP2_TAGS_SELECTED,
  (tag: UserFavouriteSubTag) => ({
    tag,
  })
);

export const setStep4TagSelected = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP3_TAGS_SELECTED,
  (item: C.CartItemDataType, type: C.CartItemType) => ({
    item,
    type,
  })
);
export const setTitle = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_TITLE,
  (title: string) => ({
    title,
  })
);

export const setDesignation = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_DESIGNATION,
  (designation: string) => ({
    designation,
  })
);

export const setDialCode = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_DIAL_CODE,
  (dialCode: string) => ({
    dialCode,
  })
);

export const setFullName = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_FULLNAME,
  (fullName: string) => ({
    fullName,
  })
);

export const setPhoneNumber = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_PHONE_NUMBER,
  (phoneNumber: string) => ({
    phoneNumber,
  })
);

export const setEmail = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_EMAIL,
  (email: string) => ({
    email,
  })
);

export const setCompany = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_COMPANY,
  (company: string) => ({
    company,
  })
);

export const setStep1Cache = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_STEP1_CACHE,
  () => ({})
);

export const setShouldShowRequestSubmittedPopup = createAction(
  C.ACTION_TYPES.DATA_INTEREST_FORM_SET_SHOULD_SHOW_REQUEST_SUBMITTED_POPUP
);

export const getStep2Data = () => async dispatch => {
  const payload = {
    depth: 2,
  };

  const json = await fetchAPI('/user_favourite_tags', {
    method: 'GET',
    version: '1.2',
    payload,
  }).then(r => r.json());

  let items = json.items.sort((a, b) => a.id - b.id);
  let childs: UserFavouriteTag[] = [];

  for (let item of items) {
    if (item.parent_id !== null) {
      childs.push(item);
    }
  }

  items = items.filter(item => item.parent_id === null);

  for (let item of items) {
    let tagChilds: UserFavouriteTag[] = [];
    for (let child of childs) {
      if (child.parent_id === item.id) {
        tagChilds.push(child);
      }
    }
    tagChilds.sort((a, b) => a.id - b.id);
    item['childs'] = tagChilds;
  }

  dispatch(setStep2Data(items));
};

export const getStep3Data = (
  tagIds: number[],
  subTagIds: number[]
) => async dispatch => {
  const payload = {
    tag_ids: tagIds,
  };

  const json = await fetchAPI('/user_favourite_tags/products', {
    method: 'GET',
    version: '1.2',
    payload: payload,
  }).then(r => r.json());

  let subTags: UserFavouriteSubTag[] = [];
  for (let tagId of tagIds) {
    let subTag: UserFavouriteSubTag = {
      product: {
        data_items: [],
        shop_item_categories: [],
        shop_items: [],
      },
      name: '',
      tag_id: tagId,
      isSubTag: subTagIds.includes(tagId),
    };

    for (let item of json.items) {
      if (item.tag_id === tagId) {
        subTag.product = { ...item };
        subTag.name = item.name;
      }
    }
    subTags.push(subTag);
  }

  dispatch(setStep3Data(subTags));
};

export const checkUserByPhoneNumber = (phone_number: string) => async (
  dispatch,
  getState
) => {
  const res = await fetchAPI(`/phone_number/${phone_number}`, {
    method: 'GET',
    version: '1.1',
  });
  return res.status == 200;
};

export const submitDataInterestForm = (items?: any) => async (
  dispatch,
  getState
) => {
  const { dataInterestForm } = getState();

  const payload = {
    id: dataInterestForm.id,
    full_name: dataInterestForm.title + dataInterestForm.fullName,
    designation: dataInterestForm.designation,
    phone_number: dataInterestForm.dialCode + dataInterestForm.phoneNumber,
    email: dataInterestForm.email,
    company: dataInterestForm.company,
    items: items,
  };
  const res = await fetchAPI('/user_data_interest', {
    method: 'POST',
    version: '1.2',
    payload: payload,
  });
  const json = await res.json();
  return json;
};



// WEBPACK FOOTER //
// ./app/actions/DataInterestFormCreators.ts